module.exports = __webpack_public_path__ + "static/media/createAssignTemplate1.34d5ce66.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Instructions/createAssignTemplate1.gif
// module id = 1251
// module chunks = 2